import React, { FunctionComponent, useEffect } from "react";

import * as H from "history";
import { useDispatch } from "react-redux";
import { Router, Switch, Route } from "react-router-dom";

import { clearBreadcrumbs } from "../../features/breadcrumbs/breadcrumbsSlice";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { Users } from './index';
import { NewUser } from './new';
import { EditUser } from './edit';
import { InfographicUser } from "./InfographicUser";

interface AdminRouterProps {
  history: H.History<any>;
}

const prefix = Prefixes.user;

export const UsersRouter: FunctionComponent<AdminRouterProps> = ({
  history,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return history.listen((location) => {
      dispatch(clearBreadcrumbs());
    });
  }, [dispatch, history]);
  return <Router history={history}>
    <Switch>
      <Route path={`${prefix}${ActionSuffixes.new}`} exact>
        <NewUser />
      </Route>
      <Route path={`${prefix}/:id/infographic`} exact>
        <InfographicUser />
      </Route>
      <Route path={`${prefix}/:id${ActionSuffixes.edit}`} exact>
        <EditUser />
      </Route>
      <Route path={prefix}>
        <Users />
      </Route>
    </Switch>
  </Router>;
};